var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let OverrideResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api");
    __publicField(this, "version", "1.0");
  }
  getOverrideSetsForFeature(featureId, tenantId) {
    return __async(this, null, function* () {
      const address = this.buildBaseAddress(tenantId, featureId);
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  createOverrideSet(tenantId, featureId, overrideData) {
    return __async(this, null, function* () {
      const address = this.buildBaseAddress(tenantId, featureId);
      const result = yield this._post(overrideData, address);
      return result.getSuccessData();
    });
  }
  createOverrideSetStage(overrideSetId, tenantId, featureId, overrideStage) {
    return __async(this, null, function* () {
      const address = `${this.buildBaseAddressId(tenantId, featureId, overrideSetId)}/stage`;
      const result = yield this._post(overrideStage, address);
      result.ensureSuccess();
    });
  }
  getOverrideSet(overrideSetId, featureId, tenantId) {
    return __async(this, null, function* () {
      const address = this.buildBaseAddressId(tenantId, featureId, overrideSetId);
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  startOverrideSet(overrideSetId, featureId, tenantId) {
    return __async(this, null, function* () {
      const address = `${this.buildBaseAddressId(tenantId, featureId, overrideSetId)}/start`;
      const result = yield this._post(void 0, address);
      result.ensureSuccess();
    });
  }
  stopOverrideSet(overrideSetId, featureId, tenantId) {
    return __async(this, null, function* () {
      const address = `${this.buildBaseAddressId(tenantId, featureId, overrideSetId)}/stop`;
      const result = yield this._post(void 0, address);
      result.ensureSuccess();
    });
  }
  advanceOverrideSet(overrideSetId, featureId, tenantId) {
    return __async(this, null, function* () {
      const address = `${this.buildBaseAddressId(tenantId, featureId, overrideSetId)}/advance`;
      const result = yield this._post(void 0, address);
      result.ensureSuccess();
    });
  }
  setOverrideSetHidden(overrideSetId, featureId, tenantId, hiddenState) {
    return __async(this, null, function* () {
      const address = `${this.buildBaseAddressId(tenantId, featureId, overrideSetId)}?hidden=${hiddenState}`;
      const result = yield this._put(void 0, address);
      result.ensureSuccess();
    });
  }
  setOverrideStageHidden(featureId, overrideSetId, stageId, tenantId) {
    return __async(this, null, function* () {
      const address = `${this.buildOverrideStageBaseAddressId(tenantId, featureId, overrideSetId, stageId)}`;
      const result = yield this._delete(address, void 0);
      result.ensureSuccess();
    });
  }
  buildBaseAddress(tenantId, featureId) {
    return `/${this.version}/tenants/${tenantId}/features/${featureId}/overrideSets`;
  }
  buildBaseAddressId(tenantId, featureId, overrideSetId) {
    return this.buildBaseAddress(tenantId, featureId) + `/${overrideSetId}`;
  }
  buildOverrideStageBaseAddressId(tenantId, featureId, overrideSetId, overrideStageId) {
    return `/${this.version}/tenants/${tenantId}/features/${featureId}/overrideSets/${overrideSetId}/overrideStage/${overrideStageId}`;
  }
};
__decorateClass([
  onError({ message: `An error occurred while loading override sets for the feature. ${continuationErrorMessage}` })
], OverrideResource.prototype, "getOverrideSetsForFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while creating the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "createOverrideSet", 1);
__decorateClass([
  onError({ message: `An error occurred while creating the override stage. ${continuationErrorMessage}` })
], OverrideResource.prototype, "createOverrideSetStage", 1);
__decorateClass([
  onError({ message: `An error occurred while getting the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "getOverrideSet", 1);
__decorateClass([
  onError({ message: `An error occurred while starting the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "startOverrideSet", 1);
__decorateClass([
  onError({ message: `An error occurred while stopping the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "stopOverrideSet", 1);
__decorateClass([
  onError({ message: `An error occurred while advancing the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "advanceOverrideSet", 1);
__decorateClass([
  onError({ message: `An error occured while hiding the override. ${continuationErrorMessage}` })
], OverrideResource.prototype, "setOverrideSetHidden", 1);
__decorateClass([
  onError({ message: `An error occured while deleting the overrideStage. ${continuationErrorMessage}` })
], OverrideResource.prototype, "setOverrideStageHidden", 1);
OverrideResource = __decorateClass([
  WPSProxyConverter()
], OverrideResource);
const OverrideResource$1 = new OverrideResource();
export {
  OverrideResource,
  OverrideResource$1 as default
};
//# sourceMappingURL=OverrideResource.js.map
